import { createHttpService } from '../ApiService';
import {
  IDriversResponse,
  IRouteAssignmentsResponse,
  IRoutesResponse,
  IVehiclesResponse,
} from './administration.interfaces';
import {
  mockDrivers,
  mockRouteAssignments,
  mockRoutes,
  mockVehicles,
} from '../../__mocks__/administration/mockRoutesAndSchedule';
import { TPaginationParams } from '../__shared/shared.interfaces';
import { normalizePaginatedResponse } from '../__shared/paginationUtils';
import isAppWithMock from 'src/utils/isAppWithMock';

export const useRoutesAndSchedulesService = () => {
  const httpAPI = createHttpService();
  const isMockData = isAppWithMock();

  const getRouteList = async (
    params: TPaginationParams
  ): Promise<IRoutesResponse> => {
    if (isMockData) {
      return normalizePaginatedResponse(
        { data: mockRoutes, count: mockRoutes.length, ...params },
        'data'
      );
    }
    const res = await httpAPI.admin.get<Record<string, unknown>>(
      '/routes',
      { params }
    );
    return normalizePaginatedResponse(res, 'data');
  };

  const getVehicleList = async (
    params: TPaginationParams
  ): Promise<IVehiclesResponse> => {
    if (isMockData) {
      return normalizePaginatedResponse(
        { data: mockVehicles, count: mockVehicles.length, ...params },
        'data'
      );
    }
    const res = await httpAPI.admin.get<Record<string, unknown>>(
      '/vehicles',
      { params }
    );
    return normalizePaginatedResponse(res, 'data');
  };

  const getRouteAssignmentList = async (
    params: TPaginationParams
  ): Promise<IRouteAssignmentsResponse> => {
    if (isMockData) {
      return normalizePaginatedResponse(
        {
          data: mockRouteAssignments,
          count: mockRouteAssignments.length,
          ...params,
        },
        'data'
      );
    }
    const res = await httpAPI.admin.get<Record<string, unknown>>(
      '/route-assignments',
      { params }
    );
    return normalizePaginatedResponse(res, 'data');
  };

  const getDriverList = async (
    params: TPaginationParams
  ): Promise<IDriversResponse> => {
    if (isMockData) {
      return normalizePaginatedResponse(
        { data: mockDrivers, count: mockDrivers.length, ...params },
        'data'
      );
    }
    const res = await httpAPI.admin.get<Record<string, unknown>>(
      '/drivers',
      { params }
    );
    return normalizePaginatedResponse(res, 'data');
  };

  return {
    getRouteList,
    getVehicleList,
    getRouteAssignmentList,
    getDriverList,
  };
};
